import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, merge } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { SnackbarService } from '../snackbar/snackbar.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class NetworkStatusService {
  private readonly networkOnlineSubject = new BehaviorSubject<boolean>(
    navigator.onLine,
  );

  constructor(
    private readonly snackbarService: SnackbarService,
    private readonly translateService: TranslateService,
  ) {}

  public initNetworkMonitoring(): void {
    // Listen to online/offline events
    const online$ = fromEvent(globalThis, 'online');
    const offline$ = fromEvent(globalThis, 'offline');

    // Merge online/offline events and start with current status
    merge(online$, offline$)
      .pipe(distinctUntilChanged())
      .subscribe((onlineOfflineEvent: Event) => {
        this.updateNetworkStatus(onlineOfflineEvent);
      });
  }

  private updateNetworkStatus(onlineOfflineEvent: Event): void {
    this.sendMessage(onlineOfflineEvent);
    this.networkOnlineSubject.next(onlineOfflineEvent.type === 'online');
  }

  private sendMessage(onlineOfflineEvent: Event): void {
    if (onlineOfflineEvent.type === 'online') {
      this.snackbarService.show(
        this.translateService.instant('components.shared.online-notification'),
      );
    } else {
      this.snackbarService.show(
        this.translateService.instant('components.shared.offline-notification'),
      );
    }
  }

  // Public methods for components to use
  getCurrentStatus(): boolean {
    return this.networkOnlineSubject.value;
  }
}
